import Salman from "../assets/salman-javaid.jpeg";

export const Slider = () => {
  return (
    <img
      src={Salman}
      alt="Salman Javed - Senior Software Engineer in Berlin"
      className="flex   w-auto object-cover h-1/2 md:h-full  w-full md:w-1/2"
    />
  );
};
